import React from "react";

import { TEXT } from "./editorText";

const P = TEXT.provenance;
const SOURCE_TAG = Object.freeze({ fact: P.fact, note: P.note });

/** The tags a line carries: 'Fact' or 'Note' by source, plus 'Unsure' when hedged; none for a plain symptom or step. */
export function tagsOf(meta) {
  if (!meta) return [];
  const tags = [];
  const base = SOURCE_TAG[meta.source];
  if (base) tags.push({ key: meta.source, label: base.label, hint: [base.hint, P.from[meta.origin]].filter(Boolean).join(", ") });
  if (meta.hedged) tags.push({ key: "unsure", label: P.unsure.label, hint: P.unsure.hint });
  return tags;
}

/** A small text badge (never colour alone) with the longer explanation as its tooltip; renders nothing for a line without provenance. */
export default function ProvenanceBadge({ meta }) {
  const tags = tagsOf(meta);
  if (!tags.length) return null;
  return (
    <span className="le-prov">
      {tags.map((t) => <span key={t.key} className={`le-tag le-tag--muted${t.key === "unsure" ? " le-tag--warn" : ""}`} title={t.hint}>{t.label}</span>)}
    </span>
  );
}
